import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import FieldSettings from "../components/FieldSettings";
import styled, { css } from "styled-components";
import queryString from "query-string";
import BasketballCourt from "../components/BasketballCourt";
import TennisCourt from "../components/TennisCourt";
import VolleyballCourt from "../components/VolleyballCourt";
import MultisportCourt from "../components/MultisportCourt";
import { FIELD_TYPES } from "../constants";
import { Background, Wrapper, Buttons, Button } from "../theme/styled";
import { saveSvgAsPng } from "save-svg-as-png";
import computedStyleToInlineStyle from "computed-style-to-inline-style";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

const Baskets = css`
  fill: ${props => props.surfaceBasket || "#d8442b"};
  visibility: hidden;
`;

const Courts = styled.div`
  #mainSurface {
    fill: ${props => props.surface || "#63a34b"};
  }

  .tennisLines {
    visibility: ${props => props.tennisLines || "hidden"};
    fill: ${props => props.tennisColor || "#8e402a"};
  }

  #tennisNet {
    visibility: ${props => props.tennisNet || "hidden"};
  }

  .basketballTwo {
    ${Baskets};
    ${props =>
      props.basketballTwo &&
      css`
        visibility: visible;
      `};
  }

  .basketball,
  .basketballOne {
    ${Baskets};
    ${props =>
      props.basketballOne &&
      css`
        visibility: visible;
      `};
  }

  #unihockeyRight,
  #unihockeyLeft {
    visibility: ${props => props.showHockeys || "hidden"};
  }

  #unihockeyLeft {
    visibility: ${props => props.showHockey1};
  }

  #wicket {
    visibility: ${props => props.showWicket || "hidden"};
  }

  .volleyballLines {
    visibility: ${props => props.volleyballLines || "hidden"};
    fill: ${props => props.surfaceVolleyball || "#00b0ff"};
  }

  #volleyballNet {
    visibility: ${props => props.volleyballNet || "hidden"};
  }

  #volleyballNetOnly {
    visibility: ${props => props.volleyballNetOnly || "hidden"};
  }

  #wicketArena {
    visibility: ${props => props.wicketArena || "hidden"};
  }

  #arena {
    visibility: ${props => props.arena || "hidden"};
  }

  .football {
    visibility: ${props => props.football || "hidden"};
  }

  .badminton {
    visibility: ${props => props.badminton || "hidden"};
  }

  #small,
  #medium,
  #high {
    visibility: hidden;
  }

  &.small #small {
    visibility: ${props => props.ballBlock || "hidden"};
  }

  &.medium #medium {
    visibility: ${props => props.ballBlock || "hidden"};
  }

  &.high #high {
    visibility: ${props => props.ballBlock || "hidden"};
  }
`;

class EditField extends Component {
  state = { size: null, type: null };

  constructor(props) {
    super(props);
    const values = queryString.parse(this.props.location.search);
    this.state = { ...values };
    const { dispatch } = this.props;
    dispatch.field.set(values);
  }

  downloadPNG = () => {
    const element = document.getElementById("court");
    computedStyleToInlineStyle(element, {
      recursive: true,
      properties: ["fill", "visibility"],
    });
    saveSvgAsPng(element, "Konfiguracja Boiska");
  };

  chooseBallBlockSize() {
    const { field } = this.props;
    const { pilkochwyt } = field.options;
    switch (pilkochwyt) {
      case "4m":
        return "small";
      case "5m":
        return "medium";
      case "6m":
        return "high";
      default:
        return "medium";
    }
  }

  renderProperSize() {
    const { field } = this.props;
    if (field && field.size) {
      return "Court" + field.size;
    } else {
      return "Court8x7";
    }
  }

  changeSurface() {
    const { field } = this.props;
    const { color } = field.options;
    if (color) {
      return color;
    }
  }

  changeBasketSurface() {
    const { field } = this.props;
    const { basketballColor } = field.options;
    if (basketballColor) {
      return basketballColor;
    }
  }

  changeVolleyballSurface() {
    const { field } = this.props;
    const { volleyballColor } = field.options;
    if (volleyballColor) {
      return volleyballColor;
    }
  }

  changeTennisSurface() {
    const { field } = this.props;
    const { tennisColor } = field.options;
    if (tennisColor) {
      return tennisColor;
    }
  }

  renderFields() {
    const { field } = this.props;
    switch (field.type) {
      case FIELD_TYPES.basketball:
        return <BasketballCourt size={this.renderProperSize()} />;
      case FIELD_TYPES.volleyball:
        return <VolleyballCourt size={this.renderProperSize()} />;
      case FIELD_TYPES.tennis:
        return <TennisCourt size={this.renderProperSize()} />;
      case FIELD_TYPES.multisport:
        return <MultisportCourt size={this.renderProperSize()} />;
      default:
        return null;
    }
  }

  render() {
    const { field } = this.props;
    const {
      basketballTwo,
      basketballOne,
      wicket,
      volleyballLines,
      unihockey,
      net,
      volleyballNet,
      tennisLines,
      wicketArena,
      arena,
      football,
      badmintonLines,
      ballBlock,
    } = field.options;
    console.log(field.options);
    return (
      <Background transparent>
        <Wrapper>
          <h1>
            <FormattedHTMLMessage
              id="edit.intro1"
              defaultMessage="Wybrałeś boisko do "
            />
            <span>
              <FormattedHTMLMessage id={`edit.intro2.${this.state.type}`} />
            </span>
            <FormattedHTMLMessage
              id="edit.intro3"
              defaultMessage=" o rozmiarze {size}"
              values={{ size: field.size }}
            />
          </h1>

          <Route component={FieldSettings} />
          <Courts
            surface={this.changeSurface()}
            surfaceBasket={this.changeBasketSurface()}
            basketballTwo={basketballTwo ? "visible" : null}
            basketballOne={basketballOne ? "visible" : null}
            showWicket={wicket ? "visible" : null}
            tennisNet={net ? "visible" : null}
            tennisLines={tennisLines ? "visible" : null}
            tennisColor={this.changeTennisSurface()}
            volleyballLines={volleyballLines ? "visible" : null}
            volleyballNet={!net ? "visible" : null}
            volleyballNetOnly={volleyballNet ? "visible" : null}
            showHockeys={unihockey === 2 ? "visible" : null}
            showHockey1={unihockey > 0 ? "visible" : null}
            surfaceVolleyball={this.changeVolleyballSurface()}
            arena={arena ? "visible" : null}
            football={football ? "visible" : null}
            ballBlock={ballBlock ? "visible" : null}
            wicketArena={wicketArena && arena ? "visible" : null}
            badminton={badmintonLines ? "visible" : null}
            className={this.chooseBallBlockSize() + " court"}
          >
            {this.renderFields()}
          </Courts>
          <Buttons>
            <Button onClick={this.downloadPNG}>
              <FormattedMessage
                id="button.save"
                defaultMessage="Zapisz Boisko"
              />
            </Button>
          </Buttons>
        </Wrapper>
      </Background>
    );
  }
}

const mapState = ({ field }) => ({ field });
EditField = connect(mapState)(EditField);
export default EditField;
